
import { Component, Prop, Vue } from "vue-property-decorator";
import BluePop from "@/views/ai-builder/components/blue-pop.vue";

@Component({ components: { BluePop } })
export default class TablePop extends Vue {
  @Prop({ type: String, default: "" }) text!: string;
}
